import { Container, Group, Title } from "@mantine/core"
import { DataFetchWrapper, Select } from "@tfg/ui"
import { useState } from "react"

import {
  FindIngestionsQueryParams,
  FindIngestionsQueryParamsStatus,
  findIngestionsHttpControllerFindIngestionsQueryParamsStatus,
} from "~/gen/api"
import { IngestionList } from "~/pages/Admin/Ingestion/ProductImport/IngestionList"
import { useFindIngestionsQuery } from "~/pages/Admin/Ingestion/ProductImport/hooks/useFindIngestionsQuery"
import { useProductImportContext } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportContext"

export function isIngestionStatusType(
  status: string | null
): status is keyof typeof findIngestionsHttpControllerFindIngestionsQueryParamsStatus {
  if (status === null) return false
  return Object.values(
    findIngestionsHttpControllerFindIngestionsQueryParamsStatus
  ).includes(status as FindIngestionsQueryParamsStatus)
}

export function IngestionListWrapper() {
  const [filters, setFilters] = useState<FindIngestionsQueryParams>({})
  const ingestionListQuery = useFindIngestionsQuery(filters)
  const { owners } = useProductImportContext()

  return (
    <Container mt="lg" fluid>
      <Title order={3} py="sm">
        Ingestions
      </Title>
      <Group mb="sm">
        <Select
          data={Object.values(
            findIngestionsHttpControllerFindIngestionsQueryParamsStatus
          )}
          placeholder="Select status"
          size="xs"
          onChange={(value: string | null) => {
            const status = isIngestionStatusType(value) ? value : undefined
            setFilters({ ...filters, status })
          }}
        />
        <Select
          data={owners}
          size="xs"
          placeholder="Select owner"
          onChange={(value) => {
            setFilters({ ...filters, emailLauncher: value ?? undefined })
          }}
        />
      </Group>
      <DataFetchWrapper query={ingestionListQuery}>
        {({ data, refetch }) => (
          <IngestionList ingestions={data.data} refetch={refetch} />
        )}
      </DataFetchWrapper>
    </Container>
  )
}
